import { useNavigate } from "react-router-dom";
import Button from "@material-ui/core/Button";
import VerticalBar from "./chart";
export default function Info() {
  let navigate = useNavigate();

  return (
    <>
      <div className="container">
        <div className="box">
          <div>
            <h1>HIV Risk Assessment Tool!</h1>
          </div>
          <div>
            <p
              className="descriptionInfo"
              style={{ fontFamily: "sans-serif", textAlign: "justify" ,padding:"30px" }}
            >
              Welcome to TransHelp HIV Risk Assessment Tool. Check if you need HIV Test or PrEP treatment by simply answering few questions. The survey will take a maximum of 15 minutes to complete.
            </p>
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              marginBottom: "50px",
            }}
          >
            <Button
              variant="contained"
              style={{ backgroundColor: "white", color: "black" }}
              onClick={() => {
                navigate("/IntroInfo");
              }}
            >
              Start
            </Button>
            <br />
          </div>
          <div>
            <a
              href="https://www.transhelp.xyz/"
              style={{ textDecoration: "none" }}
            >
              {" "}
              <Button variant="contained">Main Page</Button>
            </a>
          </div>
        </div>
      </div>
      <div style={{ marginTop: "30px" }}>
        <VerticalBar />
      </div>
    </>
  );
}
